import { render, staticRenderFns } from "./ResultsQuestion.vue?vue&type=template&id=426122aa&"
import script from "./ResultsQuestion.vue?vue&type=script&lang=js&"
export * from "./ResultsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ResultsQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VCol,VRow,VSwitch})
